import { DeviceDetailResponse } from "../../../terminal/api/TerminalForm";
import DeviceDetailInfoGridForFS010C from "./DeviceDetailInfoGridForFS010C";
import DeviceDetailInfoGridForFS010M from "./DeviceDetailInfoGridForFS010M";
import DeviceDetailInfoGridForFS045U from "./DeviceDetailInfoGridForFS045U";
import DeviceDetailInfoGridForFS045W from "./DeviceDetailInfoGridForFS045W";
import DeviceDetailInfoGridForFS050W from "./DeviceDetailInfoGridForFS050W";
import DeviceDetailInfoGridForM2U300 from "./DeviceDetailInfoGridForM2U300";

export type DeviceDetailInfoGridProps = {
  contentColor?: string;
  contentFontSize?: string;
  device: DeviceDetailResponse;
  fs045WInfo?: boolean;
};

const DeviceDetailInfoGrid: React.FC<DeviceDetailInfoGridProps> = ({
  contentColor = "#16191f",
  contentFontSize = "0.875rem",
  device,
}) => {
  switch (device.modelName) {
    case "FS010M":
      return (
        <DeviceDetailInfoGridForFS010M
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    case "FS010C":
      return (
        <DeviceDetailInfoGridForFS010C
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    case "FS045U":
      return (
        <DeviceDetailInfoGridForFS045U
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    case "FS045W":
      return (
        <DeviceDetailInfoGridForFS045W
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    case "FS050W":
      return (
        <DeviceDetailInfoGridForFS050W
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    case "m2u300":
      return (
        <DeviceDetailInfoGridForM2U300
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      );
    default:
      return (<></>);
  }
}

export default DeviceDetailInfoGrid;
